var CustomModalEvent;
(function (CustomModalEvent) {
    CustomModalEvent["MOUNT"] = "oswald-modal-mount";
    CustomModalEvent["UNMOUNT"] = "oswald-modal-unmount";
})(CustomModalEvent || (CustomModalEvent = {}));
export { CustomModalEvent, };
//# sourceMappingURL=modal-constants.js.map